<template>
  <div id="app">
    <Header/>
    <div id="content">
        <router-view />
    </div>
  </div>
</template>

<script>
import Header from "@/components/atoms/Header"

export default {
  name: 'app',
  components: {
    Header
  },
  computed: {
  }
}
</script>

<style>
  #app {
    max-width: 800px;
    margin: 0 auto;
  }

  #content {
    padding: 0 1em;
  }
</style>
